import ServiceLayout from "@/components/ServiceLayout";

export default function Wellness() {
  return (
    <ServiceLayout
      slug="employee-health-wellness"
      eyebrow="Solutions · Employee Health & Wellness"
      title="Support your people. Strengthen your business."
      intro="Employee wellbeing is business infrastructure. Through our wellness offering with EHP, Riverstone helps employers explore a program built around personalized preventive care, virtual visits, mental health support, and pharmacy services—designed to complement the benefits you already offer, not replace them."
      image="https://images.unsplash.com/photo-1758691737138-7b9b1884b1db?q=80&w=1600&auto=format&fit=crop"
      imageAlt="A team celebrating together in a bright office"
      ctaLabel="Explore Employee Wellness"
      whoFor={[
        "Employers who want to strengthen wellbeing without adding administrative burden.",
        "Teams competing for talent but priced out of richer benefit packages.",
        "Owners whose people put off routine and preventive care.",
        "Businesses exploring whether a wellness program fits their benefits strategy.",
      ]}
      problems={[
        "Benefits that feel thin next to what larger competitors offer.",
        "Employees delaying the preventive care that keeps them well.",
        "The slow drain of absenteeism and disengagement.",
        "No clear process for evaluating whether wellness programs actually fit.",
      ]}
      capabilities={[
        { title: "Employee wellbeing support", body: "Resources that help employees care for their everyday health." },
        { title: "Preventive-care support", body: "Encouraging and enabling care before problems grow." },
        { title: "Virtual visits", body: "Convenient access to care that fits working lives." },
        { title: "Mental health support", body: "Confidential help for the pressures employees actually face." },
        { title: "Pharmacy services", body: "Support that makes medications easier to manage." },
        { title: "Benefits compatibility", body: "Designed to complement your existing benefits strategy." },
        { title: "Employer evaluation", body: "A structured process to test suitability before committing." },
        { title: "Implementation support", body: "Guidance through rollout, so the program actually gets used." },
      ]}
      providerRole={[
        {
          title: "EHP’s role — program delivery",
          body: "EHP delivers the wellness program itself, including its care components and the administrative structure behind it. Program details, eligibility, and outcomes are determined and managed by EHP.",
        },
        {
          title: "Riverstone’s role — evaluation & introduction",
          body: "We help you understand whether the program could fit your workforce and benefits strategy, introduce you to EHP, and stay engaged through evaluation and implementation.",
        },
      ]}
      conversation={[
        { title: "Your people", body: "Your headcount, the shape of your workforce, and the benefits you offer today." },
        { title: "Fit & suitability", body: "How the program may complement your existing benefits—and what the evaluation process looks like." },
        { title: "Process & next steps", body: "What implementation involves, what support looks like, and what a rollout would require of your team." },
      ]}
      faqs={[
        { q: "Does this replace our health insurance?", a: "No. The program is designed to complement the benefits you already offer—not to replace health coverage." },
        { q: "What does the program cost the employer?", a: "Per the program’s current materials, the structure is designed to involve no upfront employer cost. Exact terms are confirmed during your evaluation." },
        { q: "We already offer benefits — is it still relevant?", a: "Often, yes. The program is designed to complement existing benefits. The evaluation conversation is where fit gets tested before any commitment." },
        { q: "What’s required from our team to run it?", a: "Employers complete an evaluation first; implementation is supported by EHP. The specifics are confirmed before anything begins." },
      ]}
    />
  );
}
